export var HEADER_TOAST_CONTAINER_ID = "header-toast";